module.exports = __webpack_public_path__ + "static/step_03.f80047c8.png";